import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { fetchMe, meQueryKey } from "@/lib/auth";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ context, location }) => {
    const cached = context.queryClient.getQueryData<Awaited<ReturnType<typeof fetchMe>>>(meQueryKey);
    const me =
      cached ??
      (await context.queryClient.fetchQuery({ queryKey: meQueryKey, queryFn: fetchMe }));

    if (!me) throw redirect({ to: "/" });

    // While the initial provisioned password is still in place, the user is
    // funneled to /definir-senha until they set a real one.
    if (me.mustChangePassword && location.pathname !== "/definir-senha") {
      throw redirect({ to: "/definir-senha" });
    }

    return { me };
  },
  component: () => <Outlet />,
});
